import uInt from "./u-int.mjs";
export default {
  serialize(value) {
    return uInt.serialize(value);
  },
  deserialize(value) {
    return +uInt.deserialize(value);
  }
};
//# sourceMappingURL=short-u-int.mjs.map